export default __webpack_public_path__ + "static/media/Afterparty.024105b0.png";